// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__2_UMh","slick-next":"CustomSlider_slick-next__3pJjJ"};